import { useEffect, useLayoutEffect, useRef, useState } from 'react'

import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'
import { useIntersectionObserver } from '../../../../hooks'
import { useSelectContext, useSelectFocusContext } from '../../../Select'
import { SelectedOptions } from '../SelectedOptions'

function RecipientsInput({
  droppableIndex,
  inputRef,
  maxHeight,
  maxWidth,
  name,
  optionsRef,
  ref,
  selectedOptionsProps,
  onClearAll,
  onDeleteOption,
  onInputVisibilityChange,
  ...restProps
}) {
  const {
    disabled,
    handleChangeSearch,
    searchValue,
    value: contextValue,
  } = useSelectContext()

  const values = contextValue ?? selectedOptionsProps.values

  const { focused, handleFocus } = useSelectFocusContext()

  const inputInnerRef = useRef(null)
  const [inputNode, setInputNode] = useState(null)

  function setInputRef(node) {
    inputInnerRef.current = node
    setInputNode(node)

    ref(node)

    inputRef?.(node)
  }

  useLayoutEffect(() => {
    if (focused) {
      const el = inputInnerRef.current

      el.scrollIntoView?.({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      })
    }
  }, [focused])

  useEffect(() => {
    if (!focused && inputInnerRef.current) {
      inputInnerRef.current.blur()
    }
  }, [focused])

  function observerCallback(entries) {
    const entry = entries?.[0]

    if (!entry) {
      return
    }

    onInputVisibilityChange?.(entry.isIntersecting)
  }

  useIntersectionObserver({
    observerCallback,
    observerOptions: { root: null, threshold: 0 },
    thresholdElement: inputNode,
  })

  return (
    <SelectedOptions
      {...selectedOptionsProps}
      disabled={disabled}
      droppableIndex={droppableIndex}
      isOpen={focused}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      name={name}
      ref={optionsRef}
      values={values}
      onClearAll={onClearAll}
      onDeleteOption={onDeleteOption}
    >
      <input
        {...restProps}
        name={name}
        ref={setInputRef}
        style={values.length > 0 ? EMPTY_OBJECT : { maxWidth }}
        value={searchValue || restProps.value || EMPTY_STRING}
        onChange={handleChangeSearch}
        onFocus={handleFocus}
      />
    </SelectedOptions>
  )
}

export default RecipientsInput
